/**
 * API base URL for axios/fetch.
 * Production default: same origin (nginx proxies /api → backend) — avoids CORS
 * when users open https://nexus.eufmd-tom.com or https://eufmd.fao.org.
 */
export function getApiBaseUrl(): string {
  const fromEnv = process.env.REACT_APP_API_URL;
  if (fromEnv !== undefined && fromEnv.trim() !== '') {
    return fromEnv.replace(/\/$/, '');
  }
  if (process.env.NODE_ENV === 'production') {
    return '';
  }
  return 'http://localhost:5800';
}
